// ABOUTME: Loads the spark-ui chrome on demand, so sites still on the legacy nav never fetch spark-ui
// ABOUTME: or its Kendo dependencies. Everything the shell needs is in the lazily imported module.

import Loading from "components/common/Loading";
import React, { lazy, Suspense } from "react";

const SparkApplicationLayoutView = lazy(() => import("./SparkApplicationLayoutView"));

export default function SparkApplicationLayout({ children }) {
  return (
    <Suspense fallback={<Loading />}>
      <SparkApplicationLayoutView>{children}</SparkApplicationLayoutView>
    </Suspense>
  );
}
